import { openDialog } from '@kerfjs/ui/surface-scaffold';

/** Open explicitly marked, conditionally rendered Kerf dialogs after they enter the document. */
export function wireMountedDialogSurfaces(root: HTMLElement): () => void {
  const selector = 'dialog[data-component="dialog-surface"][data-auto-open-dialog]';
  const opened = new WeakSet<HTMLDialogElement>();
  const openOnce = (dialog: HTMLDialogElement): void => {
    if (opened.has(dialog)) return;
    opened.add(dialog);
    openDialog(dialog);
  };
  const openUnder = (node: Node): void => {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) openOnce(node as HTMLDialogElement);
    for (const dialog of node.querySelectorAll<HTMLDialogElement>(selector)) {
      openOnce(dialog);
    }
  };
  const observer = new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) openUnder(node);
  });
  observer.observe(root, { childList: true, subtree: true });
  openUnder(root);
  return () => {
    observer.disconnect();
  };
}
